import React, { useEffect } from 'react';
import { Dialog } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAgreementPopupStore } from './agreementPopupStore';
import { useAgreementGate } from './useAgreementGate';

// The login token the popup was last shown for, so it opens by itself once per login.
const SHOWN_FOR_TOKEN_KEY = 'agreementPopupShownForToken';

const shownForThisLogin = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token || localStorage.getItem(SHOWN_FOR_TOKEN_KEY) === token) {
      return true;
    }
    localStorage.setItem(SHOWN_FOR_TOKEN_KEY, token);
    return false;
  } catch {
    return true;
  }
};

const AgreementRequiredModal: React.FC = () => {
  const navigate = useNavigate();
  const { isOpen, open, close } = useAgreementPopupStore();
  const { locked } = useAgreementGate();
  // Already on the agreement form: no popup asking to go there. The once-per-login popup waits for
  // the first other page instead.
  const onAgreementPage = useLocation().pathname.startsWith('/agreement');

  useEffect(() => {
    if (locked && !onAgreementPage && !shownForThisLogin()) {
      open();
    }
  }, [locked, onAgreementPage, open]);

  const signNow = () => {
    close();
    navigate('/agreement');
  };

  return (
    <Dialog open={isOpen && !onAgreementPage} onClose={close} maxWidth="xs" fullWidth>
      <div className="p-6 flex flex-col gap-3">
        <h2 className="text-lg font-semibold text-stone-800">Partner Agreement Pending</h2>
        <p className="text-sm text-stone-600">
          Please sign the partner agreement to use this feature.
        </p>
        <div className="flex justify-end gap-3 mt-3">
          <button
            type="button"
            onClick={close}
            className="h-10 rounded-xl px-5 text-sm font-semibold text-stone-600"
          >
            Later
          </button>
          <button
            type="button"
            onClick={signNow}
            className="h-10 rounded-xl px-5 text-sm font-semibold text-white bg-green-700 border border-green-700"
          >
            Sign Agreement
          </button>
        </div>
      </div>
    </Dialog>
  );
};

AgreementRequiredModal.displayName = 'AgreementRequiredModal';

export default AgreementRequiredModal;
